import "./contenitore2.css";
import Titolo from "./titolo";

function Contenitore2() {
  return (
    <div id="contenitore2" style={{ height: "100" }}>
      <div
        style={{
          height: "100",
          display: "flex",
          textAlign: "center",
          alignItems: "center",
          justifyContent: "center",
          
        }}
      >
      <Titolo/>
      
      </div>
    </div>
  );
}

export default Contenitore2;
